function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Slider, Rail, Tracks, Handles } from 'react-compound-slider';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
import classnames from 'classnames';
import { getControlledInputValue } from "../../../utils/get-controlled-input-value";
import { DEFAULT_VALUE } from "./constants";
import { getIsValueEqual } from "./utils/getIsValueEqual";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeHandleID: null,
      value: _this.props.initialValue || DEFAULT_VALUE
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      var value = _this.state.value;
      if (getIsValueEqual(previousState.value, value)) return;
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      onChange(name, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      return _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSlideEnd", function () {
      return _this.setState({
        activeHandleID: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSlideStart", function (value, _ref) {
      var activeHandleID = _ref.activeHandleID;
      return _this.setState({
        activeHandleID: activeHandleID
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          domain = _this$props2.domain,
          isShowingTrackOutsideLeft = _this$props2.isShowingTrackOutsideLeft,
          isShowingTrackOutsideRight = _this$props2.isShowingTrackOutsideRight,
          renderValue = _this$props2.renderValue,
          step = _this$props2.step;
      var value = getControlledInputValue(_this.props.value, undefined, _this.state.value);
      return React.createElement(Slider, {
        className: "ui range",
        domain: domain,
        mode: 2,
        onChange: _this.handleChange,
        onSlideEnd: _this.handleSlideEnd,
        onSlideStart: _this.handleSlideStart,
        step: step,
        values: value
      }, React.createElement(Rail, null, function (_ref2) {
        var getRailProps = _ref2.getRailProps;
        return React.createElement("div", _extends({
          className: "rail"
        }, getRailProps()));
      }), React.createElement("div", null), React.createElement(Tracks, {
        left: isShowingTrackOutsideLeft,
        right: isShowingTrackOutsideRight
      }, function (_ref3) {
        var tracks = _ref3.tracks,
            getTrackProps = _ref3.getTrackProps;
        return React.createElement(Fragment, null, tracks.map(function (_ref4, key) {
          var source = _ref4.source,
              target = _ref4.target;
          return React.createElement("div", _extends({
            className: "track",
            key: key,
            style: {
              left: "".concat(source.percent, "%"),
              width: "".concat(target.percent - source.percent, "%")
            }
          }, getTrackProps()));
        }));
      }), React.createElement(Handles, null, function (_ref5) {
        var handles = _ref5.handles,
            getHandleProps = _ref5.getHandleProps;
        return React.createElement(Fragment, null, handles.map(function (_ref6, key) {
          var id = _ref6.id,
              percent = _ref6.percent,
              value = _ref6.value;
          return React.createElement("div", _extends({
            className: classnames('handle-clickable-area', {
              active: id === _this.state.activeHandleID
            }),
            key: key,
            style: {
              left: "calc(".concat(percent, "% - 10px)")
            }
          }, getHandleProps(id)), React.createElement("div", {
            className: "handle"
          }), React.createElement(Label, {
            pointing: "below"
          }, renderValue(value)));
        }));
      }));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'Range';
Component.defaultProps = {
  domain: [0, 100],
  initialValue: undefined,
  isShowingTrackOutsideLeft: true,
  isShowingTrackOutsideRight: false,
  name: '',
  onChange: Function.prototype,
  renderValue: function renderValue(value) {
    return value;
  },
  step: 1,
  value: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  domain: PropTypes.arrayOf(PropTypes.number),
  initialValue: PropTypes.arrayOf(PropTypes.number),
  isShowingTrackOutsideLeft: PropTypes.bool,
  isShowingTrackOutsideRight: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  step: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.number)
} : {};